import {
    IStatusEtapa,
    IStatusEtapaBody,
} from "../../../Interfaces/Repasse/StatusEtapa/StatusEtapaInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarStatusEtapasDinamicasService(
    idEtapaCategoriaAtendimentoTipoCaso: number,
    idCaso: number
) {
    return Service(
        Axios.get<Array<IStatusEtapa>>(
            `/repasse/casostatus/getstatusporcasoetapacategoriaatendimentotipocaso?idCaso=${idCaso}&idEtapaCategoriaAtendimentoTipoCaso=${idEtapaCategoriaAtendimentoTipoCaso}`
        )
    );
}

export async function ListarStatusEtapaFixosService(
    idEtapaTipoCaso: number,
    idCaso: number
) {
    return Service(
        Axios.get<Array<IStatusEtapa>>(
            `/repasse/casostatus/getstatusporcasoetapatipocaso?idCaso=${idCaso}&idEtapaTipoCaso=${idEtapaTipoCaso}`
        )
    );
}

export async function InserirCasoStatusService(requestBody: IStatusEtapaBody) {
    return Service(
        Axios.post(`/repasse/casostatus/inserecasostatus`, requestBody)
    );
}
